import React from 'react';

import './menu-header.styles.scss'

export const MenuHeader = ({name}) => (

    <h2>{name}</h2>

)
